// Lấy tên hiển thị của module.
export function getModuleDisplayName(moduleCode) {
  const displayNames = {
    pms: "Quyền truy cập hệ thống",
    system: "Quản lý hệ thống",
    contract: "Quản lý hợp đồng",
    subcontract: "Quản lý giao khoán",
    equipment: "Quản lý thiết bị",
  };

  return displayNames[moduleCode] || moduleCode;
}

// Lấy tên hiển thị rút gọn của module.
export function getModuleShortName(moduleCode) {
  const displayNames = {
    pms: "Quyền truy cập",
    system: "Hệ thống",
    contract: "Hợp đồng",
    subcontract: "Giao khoán",
    equipment: "Thiết bị",
  };

  return displayNames[moduleCode] || moduleCode;
}

// Lấy tên hiển thị của resource.
export const getResourceDisplayName = (resource) => {
  const displayNames = {
    // Quản lý hệ thống
    document_type: "Danh mục tài liệu",
    personnel: "Nhân sự",
    department: "Phòng ban",
    department_unit: "Đội trong phòng ban",
    user: "Người dùng",
    contract_group: "Nhóm hợp đồng",
    contractor: "Đơn vị thi công",
    client: "Chủ đầu tư",
    role_in_contract: "Vai trò trong hợp đồng",
    unit_in_contract: "Đơn vị trong hợp đồng",
    subcontract_execution_group: "Nhóm thực hiện giao khoán",
    subcontract_execution_group_user: "Nhân sự nhóm giao khoán",
    subcontract_group: "Loại giao khoán",
    role_in_subcontract: "Vai trò trong giao khoán",
    unit_in_subcontract: "Đơn vị trong giao khoán",
    permission_function: "Phân quyền chức năng",
    permission_application: "Phân quyền ứng dụng",
    log: "Nhật ký hệ thống",
    release_log: "Nhật ký phát hành",
    // Quản lý hợp đồng
    contract: "Thông tin hợp đồng",
    contract_item: "Hạng mục hợp đồng",
    contract_payment: "Thanh toán hợp đồng",
    contract_history: "Lịch sử hợp đồng",
    calendar: "Lịch biểu",
    notification: "Thông báo",
    // Quản lý giao khoán
    dashboard: "Tổng quan",
    subcontract: "Quyết định giao khoán",
    subcontract_item: "Dự toán giao khoán",
    subcontract_history: "Lịch sử giao khoán",
    subcontract_approval: "Phê duyệt giao khoán",
    draft_item: "Dự toán giao khoán",
    subcontract_acceptance: "Nghiệm thu giao khoán",
    draft_acceptance_item: "Dự toán nghiệm thu",
    acceptance_approval: "Phê duyệt nghiệm thu giao khoán",
    subcontract_payment: "Thanh toán giao khoán",
    statistics: "Thống kê",
    // Quản lý thiết bị
    equipment: "Danh mục thiết bị",
    borrow_request: "Lập phiếu mượn",
    return_request: "Lập phiếu trả",
    borrow_history: "Lịch sử mượn",
    return_history: "Lịch sử trả",
    calibration: "Theo dõi hiệu chuẩn"
  };

  return displayNames[resource] || resource;
};

// Lấy nhãn hiển thị của action.
export const getActionLabel = (action) => {
  const labels = {
    read: "Xem",
    create: "Tạo mới",
    update: "Cập nhật",
    delete: "Xóa",
    import: "Import",
    export: "Export",
    submit: "Gửi phê duyệt",
    approve: "Phê duyệt",
    assign: "Gán quyền",
    access: "Truy cập",
  };

  return labels[action] || action;
};

// Lấy màu Material UI tương ứng với action.
export const getActionColor = (action) => {
  const colors = {
    read: "primary",
    create: "success",
    update: "warning",
    delete: "error",
    import: "info",
    export: "secondary",
    submit: "info",
    approve: "secondary",
    assign: "warning",
    access: "primary",
  };
  return colors[action] || "default";
};

// Lấy màu Material UI tương ứng với vai trò.
export const getRoleColor = (roleName) => {
  if (!roleName) return undefined;
  if (roleName === "Admin") return "#7b1fa2";
  if (roleName === "Operator") return "#1976d2";
  if (roleName === "Creator") return "#2e7d32";
  if (roleName === "Editor") return "#ed6c02";
  if (roleName === "Viewer") return "#607d8b";
  return undefined;
};

export const isAdminRole = (role) =>
  String(role?.roleName ?? role?.RoleName ?? "").toLowerCase() === "admin" ||
  String(role?.roleCode ?? role?.RoleCode ?? "").toLowerCase() === "system.admin";
